import React from 'react';

import Button from './ui/Button';
import 'bulma/css/bulma.css';
import '../css/style.css';

export default function DashboardNavigation(props) {  
	const availableSeasons = props.availableSeasons || [];
	const activeSeason = props.activeSeason;
	const showSeasonSelector = availableSeasons.length > 0;

	const handleSeasonChange = event => {
		if (props.onSeasonChange) {
			props.onSeasonChange(Number(event.target.value));
		}
	};

	const handleFilterChange = event => {
		if (props.onFilterChange) {
			props.onFilterChange(event.target.name, event.target.value);
		}
	};

	const handleSubmit = event => {
		event.preventDefault();
		if (props.onApplyFilters) {
			props.onApplyFilters();
		}
	};

	return (
		<section className="hero is-primary dashboard-bg-image">
			<div className="hero-body hero-bg-image">
				<div className="container profile">
					<div className="profile-heading">
						<div className="dashboard-profile-layout">
							<div className="dashboard-coach-summary">
								<h1 className="title coach-title coach-heading-dashboard">Coach:</h1>
								<p>
									<span className="title is-bold profile-title coach-fullname">{props.firstName} {props.lastName}</span>
								</p>
								<p>
									<span className="tagline profile-metadata coach-email">{props.email}</span>
								</p>
								{activeSeason !== null && activeSeason !== undefined ? (
									<p>
										<span className="tagline profile-metadata coach-email">Active Season: {activeSeason}</span>
									</p>
								) : null}
							</div>
							<form className="dashboard-filter-form" onSubmit={handleSubmit}>
								<div className="dashboard-filter-fields">
									<span className="dashboard-filter-control">
										<input
											id="dashboard-team-search"
											name="teamSearch"
											className="input hl-focusable"
											type="search"
											placeholder="Search teams"
											value={props.teamSearch || ''}
											onChange={handleFilterChange}
										/>
									</span>
									<span className="dashboard-filter-control">
										<input
											id="dashboard-player-search"
											name="playerSearch"
											className="input hl-focusable"
											type="search"
											placeholder="Search players"
											value={props.playerSearch || ''}
											onChange={handleFilterChange}
										/>
									</span>
									<span className="dashboard-filter-control">
										<input
											id="dashboard-position-filter"
											name="position"
											className="input hl-focusable"
											type="search"
											placeholder="Filter by position"
											value={props.position || ''}
											onChange={handleFilterChange}
										/>
									</span>
								{showSeasonSelector ? (
									<span className="dashboard-season-control">
										<label className="tagline profile-metadata coach-email" htmlFor="dashboard-season-select">
                    Season
										</label>
										<div className="select is-primary is-outlined">
											<select
												id="dashboard-season-select"
												className="hl-focusable"
												value={activeSeason !== null && activeSeason !== undefined ? activeSeason : ''}
												onChange={handleSeasonChange}
											>
												{availableSeasons.map(season => (
													<option key={season} value={season}>{season}</option>
												))}
											</select>
										</div>
									</span>
								) : null}
								</div>
								<div className="dashboard-filter-actions">
									<span>
										<Button type="submit" variant="primary">
                    Apply Filters
										</Button>
									</span>
								<span>
									<Button onClick={props.onAddTeam} isOutlined variant="primary">
                    Add a New Team
									</Button>
								</span>
								<span>
									<Button onClick={props.onAddPlayer} isOutlined variant="primary">
                    Add a New Player
									</Button>
								</span>
								<span>
									<Button onClick={props.onAddStats} isOutlined variant="primary">
                    Add New Stats
									</Button>
								</span>
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
